var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { runtime } from '../../Runtime';
import { bound } from '../../../../utils/decorators/basic';
export class BrowserAlert {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get browserRuntime() {
        return this.parent;
    }
    async getSwal() {
        await runtime.fetchPackages.Exotic;
        return runtime.availablePackages.Exotic.classes.Swal;
    }
    /* https://sweetalert2.github.io/#examples   */
    async fire(...params) {
        const Swal = await this.getSwal();
        return await Swal.fire(...params);
    }
}
__decorate([
    bound
], BrowserAlert.prototype, "fire", null);
